import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import appRoutes from '../../../../../routes/appRoutes';
import CashbackPresenter, {
  QUARANTINED,
} from '../../../../../presenters/CashbackPresenter';
import StateChangeModal from '../../../../../components/StateChangeModal';
import { Dialog } from '../../../../../components';
import { updateCashbackState, updateCashback } from '../../../../../mutations';

import CashbacksTable from './components/CashbacksTable';
import EditCashbackModal from './components/EditCashbackModal';
import Header from './components/Header';

const CashbacksList = (props) => {
  const { fastCashId, cashbacks, onDeleteCashback, relay, searchParams } =
    props;
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isEditCashbackStateDialogOpen, setIsEditCashbackStateDialogOpen] =
    useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editedCashback, setEditedCashback] = useState(null);
  const [cashbackParams, setCashbackParams] = useState({});
  const [errors, setErrors] = useState(null);

  const handleDeleteDialogOpen = (cashback) => {
    setEditedCashback(cashback);
    setIsDeleteDialogOpen(true);
  };

  const handleDialogClose = () => setIsDeleteDialogOpen(false);

  const handleEditModalOpen = (cashback) => {
    setCashbackParams(cashback);
    setIsEditModalOpen(true);
  };

  const handleEditModalClose = () => {
    setIsEditModalOpen(false);
  };

  const handleEditCashbackStateDialogOpen = (cashback) => {
    setCashbackParams(cashback);
    setIsEditCashbackStateDialogOpen(true);
  };

  const handleEditCashbackStateDialogClose = () =>
    setIsEditCashbackStateDialogOpen(false);

  const warningText = `Are you sure you want to remove $${CashbackPresenter.amount(
    editedCashback
  )} FastCash for 
    ${CashbackPresenter.name(editedCashback)}?`;

  const handleDeleteCashback = () => {
    onDeleteCashback(CashbackPresenter.id(editedCashback));
    handleDialogClose();
  };

  const history = useHistory();

  const handleButtonClick = () => {
    const path = appRoutes.newCashbackPath(fastCashId);

    history.push(path);
  };

  const handleSubmit = (values) => {
    const { id } = cashbackParams;
    const { state } = values;
    const newValues =
      state === QUARANTINED ? values : { ...values, quarantinedReason: null };
    const params = { ...searchParams, ...newValues, id };

    return updateCashbackState(relay.environment, params, {
      onCompleted: ({ updateCashbackState }) =>
        handleSubmitSuccess(updateCashbackState),
    });
  };

  const handleEditSubmit = (values) => {
    const { id } = cashbackParams;
    const params = { ...searchParams, ...values, id };

    return updateCashback(relay.environment, params, {
      onCompleted: ({ updateCashback }) => handleSubmitSuccess(updateCashback),
    });
  };

  const handleSubmitSuccess = (response) => {
    const { errors, errorMessage } = response;
    if (errors) return setErrors(errors);
    if (errorMessage) return setErrors(errorMessage);

    handleEditCashbackStateDialogClose();
    handleEditModalClose();
  };

  return (
    <div className="cashbacks">
      <Header fastCashId={fastCashId} onButtonClick={handleButtonClick} />
      <Dialog
        className="deletion"
        isOpen={isDeleteDialogOpen}
        message={warningText}
        onConfirm={handleDeleteCashback}
        onCancel={handleDialogClose}
      />
      <EditCashbackModal
        cashbackParams={cashbackParams}
        onEditCashbackModalClose={handleEditModalClose}
        isEditDialogOpen={isEditModalOpen}
        onSubmit={handleEditSubmit}
        errors={errors}
      />
      <StateChangeModal
        cashbackParams={cashbackParams}
        onEditCashbackStateDialogClose={handleEditCashbackStateDialogClose}
        isEditDialogOpen={isEditCashbackStateDialogOpen}
        onSubmit={handleSubmit}
        errors={errors}
      />
      <CashbacksTable
        fastCashId={fastCashId}
        cashbacks={cashbacks}
        onDeleteDialogOpen={handleDeleteDialogOpen}
        onEditStateDialogOpen={handleEditCashbackStateDialogOpen}
        onEditModalOpen={handleEditModalOpen}
      />
    </div>
  );
};

export default CashbacksList;

CashbacksList.propTypes = {
  searchParams: PropTypes.shape().isRequired,
  fastCashId: PropTypes.string,
  cashbacks: PropTypes.arrayOf(CashbackPresenter.shape()).isRequired,
  onDeleteCashback: PropTypes.func.isRequired,
  relay: PropTypes.shape().isRequired,
};

CashbacksList.defaultProps = {
  fastCashId: null,
};
